export function sortByProp(prop: any, order = 'asc'): (a: any, b: any) => number {
	return function (a: any, b: any): number {
		if (!a.hasOwnProperty(prop) || !b.hasOwnProperty(prop)) {
			// property doesn't exist on either object
			return 0;
		}

		const propA = typeof a[prop] === 'string' ? a[prop].toUpperCase() : a[prop];
		const propB = typeof b[prop] === 'string' ? b[prop].toUpperCase() : b[prop];

		let comparison = 0;
		if (propA > propB) {
			comparison = 1;
		} else if (propA < propB) {
			comparison = -1;
		}

		return order == 'desc' ? comparison * -1 : comparison;
	};
}
